import React from 'react';
import './App.css';
import {
  Router as RouterHistory,
  // BrowserRouter as Router,
  // Route,
  // Switch,
  // Link
} from 'react-router-dom'

import { createBrowserHistory } from 'history';

import { ThemeProvider } from '@material-ui/core/styles';
import theme from './theme/index'

import './assets/index.scss';
import 'react-perfect-scrollbar/dist/css/styles.css'

import Routes from './Routes'

import { Provider } from 'react-redux';
import store from './Redux/store';

const browserHistory = new createBrowserHistory()


function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <RouterHistory history={browserHistory}>
          <Routes />
        </RouterHistory>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
